module.exports = __webpack_public_path__ + "6946616481ddedf2eec551da6bbcbbe6.svg";